export default Object.freeze({
  I: 'Initial',
  O: 'Open',
  PA: 'Pending Approval/Approved',
  A: 'Approved',
  D: 'Dispatched',
  PX: 'Pending Cancel',
  X: 'Canceled',
  C: 'Complete',
  DA: 'Denied',
  LD: 'Line Denied',
});
